import { Pin, X } from "lucide-react";

export function PinnedBanner({ pinned, canManage, onJump, onUnpin }) {
    if (!pinned) return null;
    return (
        <div className="flex items-center gap-3 px-4 py-2.5 bg-amber-50 border-b border-amber-200" data-testid="chat-pinned-banner">
            <Pin className="w-4 h-4 text-amber-700 shrink-0" />
            <button onClick={onJump} className="flex-1 min-w-0 text-left" data-testid="chat-pinned-jump">
                <div className="text-[11px] font-semibold uppercase tracking-wider text-amber-800">Pinned · {pinned.sender_name}</div>
                <div className="text-sm text-ink truncate">{pinned.preview}</div>
            </button>
            {canManage && (
                <button onClick={onUnpin} className="p-1.5 rounded-full text-amber-800 hover:bg-amber-100" title="Unpin" data-testid="chat-unpin-btn"><X className="w-4 h-4" /></button>
            )}
        </div>
    );
}

export default PinnedBanner;
